import { fetch } from 'autofetch';
import { parse } from 'url';
import { defaults } from 'lodash';
import Store from '../store';
import { getConfig } from './sns/alipay';
import { getLocation } from './sns';

const headers = {};

const location = getLocation().then(({
  latitude,
  longitude,
}) => {
  if (latitude && latitude !== '' && longitude && longitude !== '') {
    headers['x-app-latitude'] = latitude;
    headers['x-app-longitude'] = longitude;
  }
}).catch(() => ({}));

const viewStamp = Date.now();

fetch.callback((response) => {
  return response.text().then((text) => {
    try {
      return JSON.parse(text);
    } catch (e) {
      return text;
    }
  }).then((res) => {
    if (typeof res === 'object' && ('code' in res || 'status' in res)) {
      if ([res.code, res.status].includes(200)) {
        return res.data;
      }
      return Promise.reject(res);
    }
    if (response.status < 400) {
      return res.data || res;
    }
    return Promise.reject(res);
  });
});

fetch.baseHost('/api/');

export default async (url, options = {}) => {
  options.headers = defaults(headers, options.headers);

  const {
    _source: source,
    _flag: flag,
  } = parse(window.location.href, true).query;

  if (source) {
    options.headers['x-app-source'] = source;
  }
  options.headers['x-app-viewstamp'] = viewStamp;

  const user = Store.getState().user.uuid;
  if (user) {
    options.headers['X-User-UserId'] = user;
  }
  if (window.isWechat) {
    options.headers['X-SNS-AppId'] = '';
  } else {
    options.headers['X-SNS-AppId'] = getConfig().appId;
  }

  if (flag) {
    options.headers['X-APP-FLAG'] = flag;
  }

  return fetch(url, options);
};
